import { apiPath } from "../../constants";

import {
    axios,
    history,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

import { addSuccessMessage } from 'actions';

export const REGISTER_REQUEST = 'REGISTER_USER_REQUEST';
export const REGISTER_FAILURE = 'REGISTER_USER_FAILURE';
export const REGISTER_SUCCESS = 'REGISTER_USER_SUCCESS';

export const registerUser = (username, password, redirect="/") => {
    return function(dispatch) {
        dispatch(registerUserRequest());
        return axios(apiRequestOptions(apiPath.USER.REGISTER, {username, password}, {withoutAuth: true}))
            .then(transformHttpResponse)
            .then(response => {
                dispatch(registerUserSuccess(response, redirect));
                dispatch(addSuccessMessage('User is successfully registered'));
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(registerUserFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const registerUserRequest = () => {
  return {
      type: REGISTER_REQUEST,
  }
};

const registerUserSuccess = (data, redirect) => {
    history.push(redirect);
    return {
        data,
        type: REGISTER_SUCCESS,
    }
};

const registerUserFailure = () => {
    return {
        type: REGISTER_FAILURE,
    }
};